module.exports = __webpack_public_path__ + "static/media/cap2-leg-desk.f2cb037c.png";